<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-body class="p-1">
        <b-row>
          <div class="col-12 col-md-3">
            <b-form-group label="Khoảng thời gian" class="mb-0">
              <date-picker v-model="loadDateRange" type="datetime" range ref="datetime" :shortcuts="shortcuts"
                :show-time-panel="false" format='DD/MM/YYYY' valueType="format"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"></date-picker>
            </b-form-group>
          </div>

          <b-col cols="12" md="3">
            <b-form-group label="Kênh liên kết" class="mb-0" label-for="source_id">
              <v-select v-model="source_id" class="w-100" :options="dataSource" :reduce="(val) => val.code"
                placeholder="--Chọn--" @input="(val) => $emit('update:source_id', val)" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group label="Phòng ban" class="mb-0">
              <v-select v-model="department_id" class="w-100" :options="dataDepartment" label="name"
                :reduce="(val) => val.id" placeholder="--Chọn--" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <label>Tìm kiếm</label>
            <b-input-group>
              <b-form-input v-model="localSearchQuery" class="d-inline-block" placeholder="Tiêu đề bài viết"
                @keyup.enter="updateSearchQuery" />
              <b-input-group-append>
                <b-button variant="primary" @click="updateSearchQuery">
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- List -->
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card no-body class="mb-0">
        <b-table ref="refListTable" :items="dataItems" responsive :fields="tableColumns" primary-key="id" show-empty
          empty-text="No matching records found">
          <!-- Column: Status -->
          <template #cell(title)="data">
            <a @click="showDialog(data.item.id, data.item.lang)">
              <strong v-if="data.item.lang == 'en'">{{ data.item.title_en }}</strong>
              <strong v-else>{{ data.item.title }}</strong>
            </a>
          </template>
          <template #cell(department_id)="data">
            <ul class="list_user">
              <li v-for="(val, index) in data.item.json" :key="index">
                <div class="item">
                  - {{ val.department.code }}:
                  <span v-for="(user, i) in val.list_user" :key="i">
                    {{ user.username }},
                  </span>
                </div>
              </li>
            </ul>

          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', {
                from: dataMeta.from, to: dataMeta.to, of: dataMeta.of,
              }) }}</span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BFormGroup,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useRouter, showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import CrawlerDialog from './CrawlerDialog.vue';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
library.add(faLanguage);
export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    vSelect,
    CrawlerDialog,
    BFormGroup,
    flatPickr,
    FontAwesomeIcon,
    DatePicker
  },
  data() {
    return {
      moment,
      dialog_title: 'Xem tin',
      crawler_id: '',
      lang: '',
    };
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup() {
    const { router } = useRouter();
    const refListTable = ref(null);
    const loadDateRange = ref('')
    const now = new Date()
    const tableColumns = [

      { key: 'title', sortable: false, label: 'Tiêu đề' },

      {
        key: 'source_name',
        sortable: false,
        label: 'Kênh liên kết',
        thAttr: { width: '10%' },
      },
      {
        key: 'total',
        sortable: false,
        label: 'Tổng',
        thAttr: { width: '5%' },
      },
      {
        key: 'department_id',
        sortable: false,
        label: 'Phòng ban',
        thAttr: { width: '40%' },
      },
    ];

    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 30, 50, 100];
    const searchQuery = ref('');
    const start_date = ref('');
    const end_date = ref('');
    const source_id = ref('');
    const localSearchQuery = ref('');
    const loading = ref(false);
    const dataItems = ref([]);
    const dataDepartment = ref([])
    const department_id = ref('')

    const fetchAll = () => {
      loading.value = true;
      store
        .dispatch('crawler/fetchAll', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          start_date: start_date.value,
          end_date: end_date.value,
          source_id: source_id.value,
          start_date: start_date.value,
          end_date: end_date.value,
          department_id: department_id.value,
          created: 1
        })
        .then((response) => {
          loading.value = false;
          if (response.data.code === 200) {
            dataItems.value = response.data.data;
            total.value = response.data.total;
          }
        });
    };
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    fetchAll();
    watch([perPage, searchQuery, source_id, start_date, end_date, department_id], () => {
      if (!loading.value) {
        refetchData();
      }
    });

    watch([currentPage], () => {
      if (!loading.value) {
        refetchData();
      }
    });

    const refetchData = () => {
      fetchAll();
    };
    const dataSource = [
      { label: 'CNN', code: 2 },
      { label: 'TTXVN', code: 1 },
    ];

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
    };
    const config_date = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    const shortcuts = ref([
      { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
      { text: 'Hôm qua', onClick: () => [new Date(Date.now() - 3600 * 1000 * 24), new Date()] },
      { text: 'Tuần trước', onClick: () => [new Date(Date.now() - 7 * 24 * 3600 * 1000), new Date()] },
      { text: 'Tháng hiện tại', onClick: () => [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0)] },
      { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
      { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] }
    ])

    const fetchDepartment = () => {
      store.dispatch('departments/fetchDepartments', {
        isPaginate: 1
      }).then(response => {
        if (response.data.code == 200) {
          dataDepartment.value = response.data.data
        }
      })
    }
    fetchDepartment()

    return {
      loading,
      dataItems,
      perPage,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      updateSearchQuery,
      localSearchQuery,
      config_date,
      start_date,
      end_date,
      source_id,
      dataSource,
      loadDateRange,
      dataDepartment,
      shortcuts,
      department_id
    };
  },
  methods: {

  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.list_user {
  padding: 0;
  margin: 0;
  list-style: none;

  li {}
}
</style>
